import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import Ads from '../Ads/Ads'
import Foot2 from '../Foot2/Foot2';
import TopBar from '../TopBar/TopBar';
import "./openfront.css";

import Spinner from '../Spinner/Spinner';

function OpenFront(props) {

  const { id } = useParams();

  const [openData, setOpenData] = useState([])
     const [loading, setLoading] = useState(true)



  async function openPage() {
   setLoading(true)
    const deid = encodeURIComponent(id);
    
   
    const response = await fetch(`https://nairalandclone.herokuapp.com/open/${deid}`);
    const data1 = await response.json()
    setOpenData(data1)
    setLoading(false)
    
  } 
  useEffect(()=>{  openPage()},[])

  function scrollUp() {
    window.scrollTo({top: 0, behavior: "smooth"});
  }
    function scrollDown() {
    window.scrollTo({top: document.body.scrollHeight || document.documentElement.scrollHeight, behavior: "smooth"});
}

  return (
    <><TopBar /> <div className='openfront' >
      <div className="topic" id ="okk">{openData.map(data => { return (<div> <div className='' dangerouslySetInnerHTML={{__html: data[0].title }}/></div>)} ) }</div>
      <div className="breadcrumbs"> {!loading && <Link className='bread' to="/">Nairaland Forum / Nairaland / General / </Link> } <div className="">{openData.map(data => { return (<div> <div className='' dangerouslySetInnerHTML={{__html: data[0].title }}/></div>)} ) }</div></div>

      <Ads />
      <div className="top" style={{ fontWeight: "700" }}>(1) <span className="reply" style={{ color: "rgb(4, 4, 108)" }}>(Reply)</span><span className="go" style={{ fontSize: "14px", color: "rgb(4, 4, 108)" }} onClick={scrollDown}> (Go down)</span></div>
      <div className="head">
        {openData.map(data => { return (<div> <div className='' dangerouslySetInnerHTML={{__html: data[0].topic }}/></div>)} ) }
      </div>
      <div className="mid">

           {loading ? <div className="spinn"><Spinner /></div> :
          openData.map(data => { return (<div> <div className='newtopics' dangerouslySetInnerHTML={{__html: data[0].title }}/></div>)} ) 
        }


      </div>

      <div className="top" style={{ fontWeight: "700" }}>(1) <span className="reply" style={{ color: "rgb(4, 4, 108)" }}>(Reply)</span></div><Ads /><span className="goup" style={{ fontSize: "14px", color: "rgb(4, 4, 108)" }}  onClick={scrollUp} target="#okk" > (Go Up)</span>
      

    </div><Foot2 /></>
   
  )
}

export default OpenFront